<div class="modal-dialog modal-lg">
  <div class="modal-content">
    <div class="modal-header">
      <div class="modal-title d-flex align-items-center gap-2">
        <ng-container i18n> Review & Approve Task </ng-container>
        <app-page-help articleId="hhQT8ZvJyJoUpna2ASN5nT" videoId="-"></app-page-help>
      </div>
      <a (click)="close()" class="cstm-close" data-dismiss="modal" aria-label="Close">
        <span class="far fa-times"></span>
      </a>
    </div>
    <ul class="nav top-navbar bg-white border-bottom" role="tablist" *ngIf="showTabs">
      <li
        [class.active]="tab === tabs.Message"
        matTooltip="These tasks are auto-created from a guest message and requires approval assignment."
        i18n-matTooltip
      >
        <a (click)="tab = tabs.Message">
          <ng-container i18n>From Message</ng-container>
          <span class="badge badge-secondary-danger badge-pill">{{ messageDraftTasks.count }}</span>
        </a>
      </li>
      <li
        [class.active]="tab === tabs.Review"
        matTooltip="These tasks are auto-created from a guest review and requires approval before assignment"
        i18n-matTooltip
      >
        <a (click)="tab = tabs.Review">
          <ng-container i18n>From Review</ng-container>
          <span class="badge badge-secondary-danger badge-pill">{{ reviewDraftTasks.count }}</span>
        </a>
      </li>
      <li
        [class.active]="tab === tabs.Automation"
        matTooltip="These tasks are auto-created from incident automation and requires approval before assignment"
        i18n-matTooltip
      >
        <a (click)="tab = tabs.Automation">
          <ng-container i18n>Others</ng-container>
          <span class="badge badge-secondary-danger badge-pill">{{ automationDraftTasks.count }}</span>
        </a>
      </li>
    </ul>
    <div class="modal-body">
      <app-message-draft-tasks
        #messageDraftTasks
        [class.d-none]="tab !== tabs.Message"
        [inquiryId]="data.inquiryId"
      ></app-message-draft-tasks>
      <app-review-draft-tasks #reviewDraftTasks [class.d-none]="tab !== tabs.Review"></app-review-draft-tasks>
      <app-automation-draft-tasks
        #automationDraftTasks
        [class.d-none]="tab !== tabs.Automation"
      ></app-automation-draft-tasks>
    </div>
  </div>
</div>
